import { render } from "./ResultadoMaridaje.vue?vue&type=template&id=75bb28ef&scoped=true"
import script from "./ResultadoMaridaje.vue?vue&type=script&lang=js"
export * from "./ResultadoMaridaje.vue?vue&type=script&lang=js"

import "./ResultadoMaridaje.vue?vue&type=style&index=0&id=75bb28ef&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75bb28ef"]])

export default __exports__